import axios from '@/api/axios'

const BASE_URL = process.env.VUE_APP_BASE_URL_AUTO

// 执行自动化任务
export function autoTaskRun(parameter) {
  return axios({
    url: BASE_URL + '/v1/task/run',
    method: 'post',
    data: parameter
  })
}
